import React from 'react';

const PrivacyActStatement = () => {
  return (
    <>
      <p data-testid="privacy-act-notice">
        VA will not disclose information collected on this form to any source
        other than what has been authorized under the Privacy Act of 1974 or
        title 38, Code of Federal Regulations, section 1.576 for routine uses
        (e.g., VA sends educational forms or letters with a veteran’s
        identifying information to the veteran’s school or training
        establishment to (1) assist the veteran in the completion of claims
        forms, or (2) for VA to obtain further information as may be necessary
        from the school for VA to properly process the veteran’s education claim
        or to monitor his or her progress during training) as identified in the
        VA system of records, 58VA21/22/28, Compensation, Pension, Education,
        and Veteran Readiness and Employment Records - VA, published in the
        Federal Register. Your obligation to respond is voluntary. While you do
        not have to respond, VA cannot process your claim for reimbursement of
        Licensing and Certification test fees unless the information is
        furnished as required by existing law (38 U.S.C. 3471). The responses
        you submit are considered confidential (38 U.S.C. 5701). Any information
        provided by applicants, recipients, and others may be subject to
        verification through computer matching programs with other agencies.
      </p>
    </>
  );
};

export default PrivacyActStatement;
